module.exports = __webpack_public_path__ + "img/85.332c0d0a.jpg";